const info = {
  // 中文翻译
  ZH: {
    tishi: "为您估算快递运单精确价格哟",
    destination: "目的地",
    // information: "货件信息",
    length: "长",
    width: "宽",
    weight: "重量",
    height: "高度",
    add: "添加包裹",
    del: "删除",
    start: "开始估算",
    check: "查询结果",
    jiyun: "寄运信息",
    back: "返回修改",
    names: "收件人名",
    addse: "收件人地址",
    city: "收件人城市",
    phone: "收件人电话",
    youbian: "收件邮编",
    shui: "税号",
    information: "商品信息",
    shuru: "请输入搜索关键词",
    zhou: "州省",
  },
  // 英文翻译
  EN: {
    tishi: "Estimate the exact price of express waybill for you",
    destination: "destination",
    // information: "Shipment information",
    length: "length",
    width: "width",
    weight: "weight",
    height: "height",
    add: "Add package",
    del: "del",
    start: "Start estimation",
    check: "Query results",
    jiyun: "Shipping information",
    back: "Return to modify",
    names: "name",
    addse: "address",
    city: "city",
    youbian: "ZipCode",
    phone: "phone",
    shui: "duty paragraph",
    information: "Commodity information",
    shuru: "Please enter a search keyword",
    zhou: "State/province",
  },
};
export default info;
